import { atom } from "jotai";

import { Terminal } from "../domain";

export const terminalDetailAtom = atom<Terminal | null>(null);